import * as React from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { LogOut } from 'lucide-react';
import { doLogout } from '@/services';
import { Button } from '@/components/atoms/button';


export const Route = createFileRoute('/logout')({
  component: LogoutPage
});

function LogoutPage() {
  const [isLoggingOut, setIsLoggingOut] = React.useState(true);

  const logoutMutationOptions = useMutation({
    mutationFn: doLogout,
    onSuccess: () => {
      setTimeout(() => setIsLoggingOut(false), 1500);
    },
  });

  React.useEffect(() => {
    logoutMutationOptions.mutate();
  }, []);

  if(isLoggingOut) {
    return(
      <div className="main-content">
        <div className="flex h-screen flex-col items-center justify-center">
          <div className="loader"></div>
          <div className="mt-12 text-3xl font-thin">Logging you out...</div>
        </div>
      </div>
    )
  }
  return (<div className="main-content">
    <div className="flex items-center justify-center">
      <LogOut size={64} />
    </div>
    <h1 className="mt-8 text-3xl font-thin">You have logged out.</h1>
    <div className="mt-12">
      <Link to="/"><Button>Continue Browsing</Button></Link>
    </div>
  </div>);
}
